module.exports = __webpack_public_path__ + "static/media/dollarIconGrey.255d4ae9.svg";